import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on route change, but not on language switch
// (i.e., when only the leading /fr or /en segment differs).
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const parts = pathname.split("/").filter(Boolean);
    const rest = parts.length > 0 && ["fr", "en"].includes(parts[0])
      ? parts.slice(1).join("/")
      : parts.join("/");

    const prev = window.__lastRestPath;
    window.__lastRestPath = rest;

    if (prev === rest) {
      // Same page, only language changed — do not scroll
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
